import React, { useEffect, useState, useRef, useMemo } from 'react';
import { connect } from 'react-redux';
import { Link, useParams, useNavigate } from 'react-router-dom';
import defaultValues from '../../constant/defaultValues';
import { FilterSupplier } from '../../actions/memberAction';
import AcSimpleTable from "../../components/AcSimpleTable";
import SubHeader from '../../components/SubHeader';
import { useAuth } from '../../AuthProvider';
import { hideLoading, showLoading } from "../../actions/loaderAction";
import Emitter from "../../utils/Emitter";
import { isEmpty, map } from 'lodash';
import ViewSupplierFilter from '@/components/memberFilter/ViewSupplierFilter';
import ButtonAdd from '@/components/ButtonAdd';
import {
    getAllSupllierInq,
    getOneInquiry,
    assignBulkInqquiry
} from "@/actions/inquiryAction";

import {
    setAuthHeaders,
    buildPath,
    showSuccessMessage,
    showErrorMessage,
} from "../../utils/common";

import roles from "@/constant/roles.config";
import { privateRoutePaths } from "@/routes/private.route.config";
import ToolipsCustom from '@/components/ToolipsCustom';
import SmallPopup from '@/components/SmallPopup';
import MediumPopup from "@/components/MediumPopup";
import { getCategories } from "@/actions/defaultDataAction";



function ViewSupplier(props) {

    const { id } = useParams();
    const inqID = id;

    const { admin } = defaultValues;

    const {
        user,
        isSuperAdmin,
        isPreKYCUser,
        isDemoUser,
        isEndUser,
        isViewer,
        isOpUser,
        isInqUser,isAdmin
    } = useAuth();

    const [tableKey, setTableKey] = useState(0);
    const [memberList, setMemberList] = useState([]);
    const [offset, setOffset] = useState(Number(admin.OFFSET || 0));
    const [limit, setLimit] = useState(Number(admin.LIMIT || 10));
    const [searchTxt, setSearchTxt] = useState("");
    const [loading, setLoading] = useState(false);
    const [totalRows, settotalRows] = useState(0);
    const [columnName, setColumnName] = useState("id");
    const [sortDirection, setSortDirection] = useState(admin.SORT_DIRECTION);
    const [current_page, setCurrentPage] = useState(1);
    const [nodata, setNoData] = useState(false);
    const [isButtonDisabled, setisButtonDisabled] = useState(false);
    const [smallmodalShow, setSmallModalShow] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [isFetchingMore, setIsFetchingMore] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [assignInqCompany, setAssignInqCompany] = useState(null);
    const [errors, setErrors] = useState({});
    const [selectedInquiry, setSelectedInquiry] = useState(null);
    const [showMsgPopup, setShowMsgPopup] = useState(false);
    const [isMsgOverflow, setIsMsgOverflow] = useState(false);

    const msgRef = useRef(null)

    const [listDataType, setListDataType] = useState("register");
    
    const sentinelRef = useRef(null);
    const offsetRef = useRef(offset);
    const limitRef = useRef(limit);
    const hasMoreRef = useRef(hasMore);
    const isFetchingMoreRef = useRef(isFetchingMore);
    const searchFilterObjRef = useRef(null);
    const deletedIdsRef = useRef(new Set());
    const unaccountedDeletedIdsRef = useRef(new Set());
    const fetchGenerationRef = useRef(0);

    const [rawCategories, setRawCategories] = useState([]);
    const [selectIndustry,setSelectIndustry] = useState("");
   const [industryValue, setIndustryValue] = useState(null);
    const OTHER_LABEL = "Other"; 

  
    const [searchFilterObj, setFilterObj] = useState({
        filter_country: [],
        filterMemberId: [],
        filterBy: inqID,
        filter_type: "",
        offset: Number(admin.OFFSET || 0),
        limit: Number(admin.LIMIT || 10),
        columnName: "id",
        sortDirection: admin.SORT_DIRECTION,
        filter_val: "",
        table_search: "",
        filter_data_type:"register",
        other_cat_supplier: [],
    });
const hasValue = (v) =>
    Array.isArray(v) ? v.length > 0 : String(v ?? "").trim() !== "";

// true only if the user applied a search / country / category / tag
const isFilterApplied = () => {
    const f = searchFilterObj || {};
    return (
        hasValue(f.filter_country) ||
        hasValue(f.filterMemberId) ||
        hasValue(f.filter_type) ||
        hasValue(f.filter_val) ||
        hasValue(f.table_search) || hasValue(f.other_cat_supplier)
    );
};

const getIndustryValue = (selectIndustry, categoryList) => {
  const normalize = (s) => String(s ?? "").trim().toLowerCase();

  const matched = categoryList.find(
    (c) => normalize(c.rawLabel) === normalize(selectIndustry)
  );
  if (matched) return matched.label;

  const other = categoryList.find(
    (c) => normalize(c.rawLabel) === normalize(OTHER_LABEL)
  );
  return other ? other.label : null; 
};


useEffect(() => {
  const fetchCategory = async () => {
    const response = await props.getCategories();
    if (!isEmpty(response)) {
      setRawCategories(
        map(response, (v) => ({
          label: v.category_name,
          rawLabel: v.category_name,
          value: v.id,
        }))
      );
    }
  };
  fetchCategory();
}, []);

useEffect(() => {
  if (!isEmpty(rawCategories) && selectIndustry) {
    setIndustryValue(getIndustryValue(selectIndustry, rawCategories));
  }
}, [rawCategories, selectIndustry]);


const isDefaultAssign = !isFilterApplied() && selectedIds.length === 0;



    const getCurrentDataType = () =>
        searchFilterObjRef.current?.filter_data_type || "register";
   
    useEffect(() => {
        offsetRef.current = offset;
    }, [offset]);


    useEffect(() => {
        limitRef.current = limit;
    }, [limit]);


    useEffect(() => {
        hasMoreRef.current = hasMore;
    }, [hasMore]);


    useEffect(() => {
        isFetchingMoreRef.current = isFetchingMore;
    }, [isFetchingMore]);


    useEffect(() => {
        searchFilterObjRef.current = searchFilterObj;
    }, [searchFilterObj]);

    useEffect(() => {
    const checkMessageOverflow = () => {
        const element = msgRef.current;

        if (!element) {
            setIsMsgOverflow(false);
            return;
        }

        setIsMsgOverflow(
            element.scrollHeight > element.clientHeight + 1
        );
    };

    const timer = requestAnimationFrame(checkMessageOverflow);

    window.addEventListener('resize', checkMessageOverflow);

    return () => {
        cancelAnimationFrame(timer);
        window.removeEventListener('resize', checkMessageOverflow);
    };
    }, [selectedInquiry?.message]);

    const headers = setAuthHeaders();

    const handleDeleteRow = async (row) => {

        if (!row || !row.id) {
            return;
        }

        const idStr = String(row.id);

        try {

            deletedIdsRef.current.add(idStr);

            const currentFilterMemberId = (
                searchFilterObjRef.current?.filterMemberId || []
            ).map(String);

            const wasConstrainedByMemberId =
                currentFilterMemberId.includes(idStr);

            if (!wasConstrainedByMemberId) {

                unaccountedDeletedIdsRef.current.add(idStr);
            }

            setMemberList((prevList) =>
                prevList.filter(
                    (item) =>
                        String(item.id) !== idStr
                )
            );

            setSelectedIds((prevSelectedIds) =>
                prevSelectedIds.filter(
                    (sid) =>
                        String(sid) !== idStr
                )
            );


            const updatedFilter = {
                ...searchFilterObjRef.current,

                filterMemberId:
                    currentFilterMemberId.filter(
                        (fid) =>
                            fid !== idStr
                    ),

                offset: Number(admin.OFFSET || 0),

                limit: Number(
                    limitRef.current ||
                    admin.LIMIT ||
                    10
                ),

                excludeMemberId:
                    Array.from(
                        deletedIdsRef.current
                    ).map(
                        (id) =>
                            String(id)
                    ),
            };


            searchFilterObjRef.current = updatedFilter;
            setFilterObj(updatedFilter);

            setOffset(
                Number(admin.OFFSET || 0)
            );

            setCurrentPage(1);

            setHasMore(true);

            hasMoreRef.current = true;


            await beginFreshFetch(updatedFilter);

            Emitter.emit(
                "REMOVE_SUPPLIER_TAG",
                row.id
            );

        } catch (error) {

            console.error(
                "handleDeleteRow error:",
                error
            );

        }
    };


    const handleRemoveMemberFromTable = (
        memberIdOrIds
    ) => {

        try {

            if (
                memberIdOrIds === undefined ||
                memberIdOrIds === null
            ) {
                return;
            }


            const ids = Array.isArray(
                memberIdOrIds
            )
                ? memberIdOrIds
                : [memberIdOrIds];


            if (ids.length === 0) {
                return;
            }


            const idSet = new Set(
                ids.map(
                    (mid) =>
                        String(mid)
                )
            );


            const currentFilterMemberIdForCheck = (
                searchFilterObjRef.current?.filterMemberId || []
            ).map(String);

            idSet.forEach((idStr) => {

                if (
                    !currentFilterMemberIdForCheck.includes(
                        idStr
                    )
                ) {

                    unaccountedDeletedIdsRef.current.add(
                        idStr
                    );

                }

            });


            /*
             * Remove rows.
             */
            setMemberList(
                (prevList) =>
                    prevList.filter(
                        (item) =>
                            !idSet.has(
                                String(item.id)
                            )
                    )
            );


            /*
             * Remove selections.
             */
            setSelectedIds(
                (prevSelectedIds) =>
                    prevSelectedIds.filter(
                        (sid) =>
                            !idSet.has(
                                String(sid)
                            )
                    )
            );


            /*
             * Keep removed IDs so that the API total
             * can be converted into the visible total.
             */
            ids.forEach((memberId) => {
                deletedIdsRef.current.add(
                    String(memberId)
                );
            });


            /*
             * Remove from current filter.
             */
            // setFilterObj((prev) => {

            //     const updatedFilterMemberId =
            //         (
            //             prev.filterMemberId || []
            //         ).filter(
            //             (fid) =>
            //                 !idSet.has(
            //                     String(fid)
            //                 )
            //         );


            //     return {
            //         ...prev,
            //         filterMemberId:
            //             updatedFilterMemberId
            //     };

            // });
            const currentFilter = {
                ...(searchFilterObjRef.current || {}),
            };

            const updatedFilter = {
                ...currentFilter,

                filterMemberId: (
                    currentFilter.filterMemberId ||
                    []
                ).filter(
                    (id) =>
                        !idSet.has(
                            String(id)
                        )
                ),

                excludeMemberId:
                    Array.from(
                        deletedIdsRef.current
                    ).map(
                        (id) =>
                            String(id)
                    ),
            };

            searchFilterObjRef.current =
                updatedFilter;

            setFilterObj(updatedFilter);

        } catch (error) {

            console.error(
                "handleRemoveMemberFromTable error:",
                error
            );

        }
    };


    const getPrefix = () => {

        if (user && isPreKYCUser) {
            return roles.PRE_KYC.prefix;
        }

        if (user && isDemoUser) {
            return roles.DEMO.prefix;
        }

        if (user && isEndUser) {
            return roles.END_USER.prefix;
        }

        if (user && isViewer) {
            return roles.VIEWER.prefix;
        }

        return roles.SUPER_ADMIN.prefix;
    };


    const columns = [

        {
            name: 'Orex ID',

            selector: row => (
                <div className='text-wrap'>
                    {row.member_unique_number}
                </div>
            ),

            width: "9%",

            columnName:
                'member_unique_number',

            sortable: false
        },


        {
            name: 'Company Name',

            selector: row => (
                <div className='text-wrap'>
                    {row.company_name}
                </div>
            ),

            width: "23%",

            columnName:
                'company_name',

            sortable: false
        },

       {
            name: 'Category',

            selector: row => {
                const industryName =
                    row.member_industry?.industy_name || row.member_industry?.industy_name;

                const resolveName = (name) => {
                    if (!name) return null;
                    if (name === 'Other') {
                        return industryName ? `Other (${industryName})` : 'Other';
                    }
                    return name;
                };

                // Collect category from every product, fall back to row.category
                const rawNames = row.products?.length
                    ? row.products.map(p => p?.category?.category_name)
                    : [row.category?.category_name];

                // Resolve "Other", drop empties, remove duplicates
                const names = [...new Set(rawNames.map(resolveName).filter(Boolean))];

                return (
                    <div className='text-wrap text-capitalize'>
                        {names.length ? names.join(', ') : row.member_industry?.industy_name}
                    </div>
                );
            },

            width: "18%",
            columnName: 'category',
            sortable: false
        },


       


        {
            name: 'Email',

            selector: row => (
                <div className='text-wrap'>
                    {row.email}
                </div>
            ),

            width: "20%",

            columnName: 'email',

            sortable: false
        },


        {
            name: 'Country',

            selector: row => (
                <div className='text-wrap'>
                    {row.country_name}
                </div>
            ),

            width: "10%",

            columnName:
                "country_name",

            sortable: false
        },


        {
            name: 'Phone',

            selector: row => (
                <div className='text-wrap'>
                    {row.phone}
                </div>
            ),

            width: "11%",

            columnName:
                "phone",

            sortable: false
        },


        // {
        //     name: 'Status',

        //     selector: row => (
        //         <i
        //             className={
        //                 row.mail_status
        //             }
        //         ></i>
        //     ),

        //     width: "4%",

        //     columnName:
        //         "mail_status",

        //     sortable: false
        // },

      ...(isSuperAdmin
    ? [
          {
              name: 'Action',
              cell: row => (
                  <div>
                      {row.mail_status ? (
                          <i className={row.mail_status} />
                      ) : (
                          <ToolipsCustom
                              subtitle="Delete"
                              className="fa-solid fa-trash-can icon-trash border-0"
                              classNameChild="data-table-tooltiop"
                              onClick={() => handleDeleteRow(row)}
                          />
                      )}
                  </div>
              ),
              width: '10%',
              columnName: '',
              sortable: false,
          },
      ]
    : [])

    ];

    const isSuccessResponse = (
        response
    ) => {

        if (!response) {
            return false;
        }

        if (
            response.status === true ||
            response.status === 'success' ||
            response.status === 200
        ) {
            return true;
        }

        if (
            response.success === true
        ) {
            return true;
        }

        if (
            Array.isArray(response)
        ) {
            return true;
        }

        if (
            response.data &&
            (
                response.data.status === true ||
                response.data.success === true
            )
        ) {
            return true;
        }

        return false;
    };


    const extractRows = (
        response
    ) => {

        if (
            Array.isArray(response)
        ) {
            return response;
        }

        if (
            Array.isArray(response?.data)
        ) {
            return response.data;
        }

        if (
            Array.isArray(
                response?.data?.data
            )
        ) {
            return response.data.data;
        }

        if (
            Array.isArray(response?.result)
        ) {
            return response.result;
        }

        return [];
    };


    /*
    |--------------------------------------------------------------------------
    | Extract Total
    |--------------------------------------------------------------------------
    */

    const extractTotal = (
        response,
        rows = []
    ) => {

        const candidates = [

            response?.metadata?.total,

            response?.data?.metadata?.total,

            response?.pagination?.total,

            response?.data?.pagination?.total,

            response?.total,

            response?.data?.total,

            response?.metadata?.count,

            response?.data?.metadata?.count,

            response?.count,

            response?.data?.count,

        ];


        const found =
            candidates.find(
                (value) =>
                    value !== undefined &&
                    value !== null &&
                    value !== '' &&
                    !Number.isNaN(
                        Number(value)
                    )
            );


        return {

            total:
                found !== undefined
                    ? Number(found)
                    : null,

            isKnown:
                found !== undefined,

        };
    };


    /*
    |--------------------------------------------------------------------------
    | Fetch Supplier Members
    |--------------------------------------------------------------------------
    */

    const fetchSupplierMembers = async (
        fObj,
        append = false
    ) => {

        const myGen =
            fetchGenerationRef.current;

         const requestedType = fObj?.filter_data_type || "register";
        /*
         * Only show main loader for fresh requests.
         */
        if (!append) {

            props.showLoading();

            setNoData(false);

        }


        try {

            const response =
                await props.FilterSupplierMembers(
                    fObj
                );


            /*
             * Ignore old request.
             */
            if (
                myGen !==
                fetchGenerationRef.current
            ) {
                return;
            }


            if (
                !isSuccessResponse(response)
            ) {

                if (!append) {

                    setMemberList([]);

                    settotalRows(0);

                    setHasMore(false);

                    setNoData(true);

                    setListDataType(requestedType);

                }

                return;
            }


            /*
             * API rows.
             */
            const rows =
                extractRows(response);


            /*
             * Remove deleted IDs.
             *
             * This is a safety net for races where the server hasn't
             * caught up with the just-updated filter yet (e.g. a
             * fresh fetch that was already in flight when a row was
             * deleted). It should normally be a no-op, since the
             * request we just sent already had the deleted id removed
             * from filterMemberId / added to excludeMemberId.
             */
            const newRows =
                rows.filter(
                    (row) =>
                        row &&
                        row.id !== undefined &&
                        !deletedIdsRef.current.has(
                            String(row.id)
                        )
                );


            /*
             * API total.
             */
            const {
                total,
                isKnown
            } = extractTotal(
                response,
                rows
            );


            const pageSize =
                Number(
                    fObj?.limit ||
                    limitRef.current ||
                    admin.LIMIT ||
                    10
                );


            /*
            |--------------------------------------------------------------------------
            | IMPORTANT — do NOT subtract deletedIdsRef.size here.
            |--------------------------------------------------------------------------
            |
            | The filter object we send (fObj) already excludes deleted
            | rows: handleDeleteRow / handleRemoveMemberFromTable both
            | strip the deleted id out of filterMemberId AND add it to
            | excludeMemberId before this request goes out. So the
            | "total" the API returns for THIS request already reflects
            | every deletion made so far.
            |
            | Previously this code did:
            |
            |     effectiveTotal = total - deletedIdsRef.current.size
            |
            | which subtracted the deleted count a SECOND time on top of
            | a total that was already reduced — e.g. 17 total members,
            | delete 1 -> API correctly returns total = 16, but the old
            | code then computed 16 - 1 = 15, one too few. Each
            | additional delete compounded the same double-count.
            |
            | The fix: trust the API's total as-is once it's known, and
            | only subtract deletions the API genuinely couldn't have
            | accounted for (tracked in unaccountedDeletedIdsRef — see
            | handleDeleteRow / handleRemoveMemberFromTable). Those are
            | deletions made while filterMemberId was empty (a general
            | country/category/search filter), where the list endpoint
            | has no id-based mechanism to exclude the row from its own
            | count.
            */
            const effectiveTotal =
                isKnown
                    ? Math.max(
                        0,
                        Number(total) -
                        unaccountedDeletedIdsRef.current.size
                    )
                    : null;
            // const effectiveTotal = isKnown ? Math.max(0, Number(total)) : null;


            /*
            |--------------------------------------------------------------------------
            | Append / Load More
            |--------------------------------------------------------------------------
            */

            if (append) {

                setMemberList(
                    (prevList) => {

                        /*
                         * Existing IDs.
                         */
                        const existingIds =
                            new Set(
                                prevList.map(
                                    (item) =>
                                        String(
                                            item.id
                                        )
                                )
                            );


                        /*
                         * Remove duplicates.
                         */
                        const uniqueNewRows =
                            newRows.filter(
                                (item) =>
                                    !existingIds.has(
                                        String(
                                            item.id
                                        )
                                    )
                            );


                        /*
                         * Final list.
                         */
                        const combined = [
                            ...prevList,
                            ...uniqueNewRows
                        ];


                        if (isKnown) {

                            /*
                             * Use the API's own total directly — it
                             * already accounts for deleted rows via
                             * the filter object (see note above).
                             */
                            settotalRows(
                                effectiveTotal
                            );


                            /*
                             * More rows available?
                             */
                            setHasMore(
                                combined.length <
                                effectiveTotal
                            );

                        } else {

                            settotalRows(
                                combined.length
                            );


                            setHasMore(
                                uniqueNewRows.length >=
                                pageSize
                            );
                        }


                        setNoData(
                            combined.length === 0
                        );


                        return combined;

                    }
                );

            }

            /*
            |--------------------------------------------------------------------------
            | Fresh Load / Filter
            |--------------------------------------------------------------------------
            */

            else {

                setListDataType(requestedType);

                setMemberList(
                    newRows
                );


                setSelectedIds([]);


                if (isKnown) {

                    settotalRows(
                        effectiveTotal
                    );


                    setHasMore(
                        newRows.length <
                        effectiveTotal
                    );


                    setNoData(
                        effectiveTotal === 0
                    );

                }

                else {

                    settotalRows(
                        newRows.length
                    );


                    setHasMore(
                        newRows.length >=
                        pageSize
                    );


                    setNoData(
                        newRows.length === 0
                    );
                }
            }


        } catch (err) {

            console.error(
                "FilterSupplierMembers Error:",
                err
            );


            if (!append) {

                setMemberList([]);

                settotalRows(0);

                setHasMore(false);

                setNoData(true);

            }

        } finally {

            if (append) {

                setIsFetchingMore(false);

                isFetchingMoreRef.current =
                    false;

                setButtonDisabled(false);

            }

            else {

                props.hideLoading();

            }
        }
    };


   
    const beginFreshFetch = async (
        fObj
    ) => {

        setHasMore(true);

        hasMoreRef.current = true;


        setIsFetchingMore(false);

        isFetchingMoreRef.current =
            false;


        setLoading(false);

        fetchGenerationRef.current += 1;


        await fetchSupplierMembers(
            fObj,
            false
        );
    };


    /*
    |--------------------------------------------------------------------------
    | Filter Supplier Members
    |--------------------------------------------------------------------------
    */

    const filterSupplierMembersData = async (
        ofst = 0,
        lmt = 10,
        page = 1,
        colName = "id",
        sortDir = "DESC",
        searchval = ""
    ) => {

        const fObj = {

            ...searchFilterObj,

            offset: Number(ofst),

            limit: Number(lmt),

            columnName:
                colName,

            sortDirection:
                sortDir,

            table_search:
                searchval,

        };


        searchFilterObjRef.current =
            fObj;


        setFilterObj(
            fObj
        );


        await beginFreshFetch(
            fObj
        );
    };


   
    const handleSort = async (
        column,
        sortDir
    ) => {

        setColumnName(
            column.columnName
        );

        setSortDirection(
            sortDir
        );

        setOffset(
            Number(admin.OFFSET || 0)
        );


        await filterSupplierMembersData(

            Number(admin.OFFSET || 0),

            Number(
                limit ||
                admin.LIMIT ||
                10
            ),

            1,

            column.columnName,

            sortDir,

            searchTxt

        );
    };


    /*
    |--------------------------------------------------------------------------
    | Apply Filter
    |--------------------------------------------------------------------------
    */

    const filterApplyOnSupplierMembers = (
        incomingFilter
    ) => {

        const normalizedLimit =
            Number(
                incomingFilter?.limit ||
                admin.LIMIT ||
                10
            );
        
         const base = searchFilterObjRef.current || searchFilterObj;

        const merged = {
            ...base,
            ...searchFilterObj,

            ...incomingFilter,

            offset:
                Number(
                    admin.OFFSET || 0
                ),

            limit:
                normalizedLimit,

            filter_data_type:
                incomingFilter?.filter_data_type || base?.filter_data_type || "register",

            excludeMemberId: [],

        };


          deletedIdsRef.current =
            new Set();

        unaccountedDeletedIdsRef.current =
            new Set();


        searchFilterObjRef.current =
            merged;


        setFilterObj(
            merged
        );


        setOffset(
            Number(admin.OFFSET || 0)
        );


        setLimit(
            normalizedLimit
        );


        setColumnName(
            merged.columnName ||
            "id"
        );


        setSortDirection(
            merged.sortDirection ||
            admin.SORT_DIRECTION
        );


        setCurrentPage(1);


        setSearchTxt(
            merged.table_search ||
            ""
        );


        setTableKey(
            (prev) =>
                prev + 1
        );


        beginFreshFetch(
            merged
        );
    };


    /*
    |--------------------------------------------------------------------------
    | Filter Ref
    |--------------------------------------------------------------------------
    */

    const filterApplyOnSupplierMembersRef =
        useRef(
            filterApplyOnSupplierMembers
        );


    filterApplyOnSupplierMembersRef.current =
        filterApplyOnSupplierMembers;


    /*
    |--------------------------------------------------------------------------
    | Load More
    |--------------------------------------------------------------------------
    */

    const loadMoreMembers = async () => {

        /*
         * Prevent duplicate requests.
         */
        if (
            isFetchingMoreRef.current ||
            !hasMoreRef.current
        ) {
            return;
        }


        setButtonDisabled(true);

        isFetchingMoreRef.current =
            true;

        setIsFetchingMore(true);


        /*
         * Always convert to Number.
         */
        const currentOffset =
            Number(
                offsetRef.current || 0
            );

        const currentLimit =
            Number(
                limitRef.current ||
                admin.LIMIT ||
                10
            );


        const nextOffset =
            currentOffset +
            currentLimit;


        /*
         * Update ref immediately.
         */
        offsetRef.current =
            nextOffset;


        const fObj = {

            ...searchFilterObjRef.current,

            offset:
                nextOffset,

            limit:
                currentLimit,

        };


        /*
         * Keep filter ref synced.
         */
        searchFilterObjRef.current =
            fObj;


        setOffset(
            nextOffset
        );


        setFilterObj(
            fObj
        );


        await fetchSupplierMembers(
            fObj,
            true
        );
    };


    /*
    |--------------------------------------------------------------------------
    | Initial Fetch
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        searchFilterObjRef.current =
            searchFilterObj;

        offsetRef.current =
            Number(
                searchFilterObj.offset || 0
            );

        limitRef.current =
            Number(
                searchFilterObj.limit ||
                admin.LIMIT ||
                10
            );

        fetchSupplierMembers(
            searchFilterObj,
            false
        );

    }, []);


    /*
    |--------------------------------------------------------------------------
    | Filter Event
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const handler =
            (incomingFilter) => {

                filterApplyOnSupplierMembersRef
                    .current(
                        incomingFilter
                    );
            };


        Emitter.on(
            "FILTER_SUPPLIER_MEMBERS",
            handler
        );


        return () => {

            Emitter.off(
                "FILTER_SUPPLIER_MEMBERS",
                handler
            );

        };

    }, []);


    /*
    |--------------------------------------------------------------------------
    | Remove Member Tag Event
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        Emitter.on(
            "REMOVE_MEMBER_ID_TAG",
            handleRemoveMemberFromTable
        );


        return () => {

            Emitter.off(
                "REMOVE_MEMBER_ID_TAG",
                handleRemoveMemberFromTable
            );

        };

    }, []);


    /*
    |--------------------------------------------------------------------------
    | Open Assign Modal
    |--------------------------------------------------------------------------
    */

    const handleInqAssign = () => {
        setSmallModalShow(true);
    };


    /*
    |--------------------------------------------------------------------------
    | Assign
    |--------------------------------------------------------------------------
    */

    const handleAssign = async () => {
        try {
            setisButtonDisabled(true);
            await props.showLoading();

            const dataType = getCurrentDataType();

            // Always use the latest filter
            const currentFilter = {
                ...(searchFilterObjRef.current || {}),
            };

            // IDs manually removed from the table
            const excludeMemberId = Array.from(
                deletedIdsRef.current || new Set()
            ).map((id) => String(id));

            // Remove deleted IDs from filterMemberId also
            const filteredMemberIds = (
                currentFilter.filterMemberId || []
            ).filter(
                (id) =>
                    !excludeMemberId.includes(String(id))
            );

            const finalFilters = {
                ...currentFilter,

                filterMemberId: filteredMemberIds,
                filter_data_type: dataType,
                // IMPORTANT:
                // Laravel should exclude these IDs when select_all=true
                excludeMemberId: excludeMemberId,

                offset: Number(admin.OFFSET || 0),
                limit: Number(
                    limitRef.current ||
                    admin.LIMIT ||
                    10
                ),
            };

            // Remove deleted IDs from manually selected IDs too
            const validSelectedIds = (
                selectedIds || []
            )
                .map((id) => String(id))
                .filter(
                    (id) =>
                        !excludeMemberId.includes(id)
                );

            const hasManualSelection =
                validSelectedIds.length > 0;

            let payload;

            if (hasManualSelection) {
                payload = {
                    inquiry_id: inqID,
                    select_all: false,
                    data_type: dataType,
                    // Deleted IDs are NOT included
                    member_ids: validSelectedIds,
                };
            } else {
                payload = {
                    inquiry_id: inqID,
                    select_all: true,
                    data_type: dataType,
                    // Backend resolves all matching IDs
                    // and excludes excludeMemberId
                    filters: finalFilters,
                };
            }

            console.log(
                "========== ASSIGN PAYLOAD =========="
            );

            console.log(
                JSON.stringify(payload, null, 2)
            );

            console.log(
                "Excluded Member IDs:",
                excludeMemberId
            );

            const response =
                await props.assignBulkInq(payload);
            console.log("response==========",response);
            const res = response?.data ?? response;
            if (
                res &&
                res.status === true
            ) {
                getInquiries(inqID);
                // Clear selections only after successful assignment
                setSelectedIds([]);

                setAssignInqCompany(null);

                setErrors({});

                // Clear removed IDs only after success
                deletedIdsRef.current = new Set();

                unaccountedDeletedIdsRef.current = new Set();

                const filterObj = {
                    filter_country: [],
                    filterMemberId: [],
                    other_cat_supplier: [],          

                    filterBy: inqID,

                    filter_type: "",

                    offset: Number(
                        0
                    ),

                    limit: Number(
                        10
                    ),

                    columnName: "id",

                    sortDirection:
                        admin.SORT_DIRECTION,

                    filter_val: "",

                    table_search: "",

                    excludeMemberId: [],

                    filter_data_type:dataType
                };

                // Keep ref and state synchronized
                searchFilterObjRef.current =
                    filterObj;

                setFilterObj(filterObj);

                setOffset(
                    Number(admin.OFFSET || 0)
                );

                offsetRef.current =
                    Number(admin.OFFSET || 0);

                setLimit(
                    Number(admin.LIMIT || 10)
                );

                limitRef.current =
                    Number(admin.LIMIT || 10);
                console.log("admin.LIMIT --",admin.LIMIT);
                console.log("admin.OFFSET --",admin.OFFSET);
                setCurrentPage(1);

                setHasMore(true);

                hasMoreRef.current = true;

                setIsFetchingMore(false);

                isFetchingMoreRef.current =
                    false;

                setSmallModalShow(false);

            
                // Emitter.emit(
                //     "FILTER_SUPPLIER_MEMBERS",
                //     filterObj
                // );
                await beginFreshFetch(filterObj);
                Emitter.emit(
                    "RESET_SUPPLIER_FILTER"
                );

                // setTimeout(() => {
                //     showSuccessMessage(
                //         response.message
                //     );
                // }, 1000);
                 setTimeout(() => {
                    showSuccessMessage(res.message);   // <-- use res, not response
                }, 1000);
                console.log("filterObj --",filterObj);
            } 
            // else {
            //     console.log("Assign failed:", response.data?.message, response?.errors);
            //     console.log(
            //         "Assign failed:",
            //         response
            //     );
            // }
        } catch (error) {
            setSmallModalShow(false);
            const status = error?.response?.status;
            const data = error?.response?.data;
            setTimeout(() => {
                showErrorMessage(data?.message);
            }, 1000);

        } finally {
            setisButtonDisabled(false);

            await props.hideLoading();
        }
    };


    /*
    |--------------------------------------------------------------------------
    | Get Inquiry
    |--------------------------------------------------------------------------
    */

    const getInquiries = async (
        inquiryId
    ) => {

        await props.showLoading();


        await props
            .getInquiries(
                inquiryId
            )
            .then(
                (response) => {

                    setSelectedInquiry(
                        response.data
                    );
                    setSelectIndustry(response.data.industry);

                }
            )
            .catch(
                (err) => {

                    console.log(
                        "Error ==== ",
                        err
                    );

                }
            );


        await props.hideLoading();
    };


    useEffect(() => {

        getInquiries(
            inqID
        );

    }, []);

    const isAssignedRow = (row) => {
    const s = row?.mail_status;
    if (s === undefined || s === null) return false;
    const str = String(s).trim();
    return str !== "" && str !== "0" && str.toLowerCase() !== "false";
};

const { assignedCount, notAssignedCount } = useMemo(() => {
    let assigned = 0;
    memberList.forEach((row) => {
        if (isAssignedRow(row)) assigned += 1;
    });
    return {
        assignedCount: assigned,
        notAssignedCount: memberList.length - assigned,
    };
}, [memberList]);

    console.log("selectedInquiry ----------",selectedInquiry);

    return (

        <>

            <div className='data-table-main logistic-table'>

                <div className="AcSimpleTable">


                    <SubHeader

                        layer1="All Inquiries"

                        layer2="Supplier Inquiries"

                        layer3="Assign Inquiry to Suppliers"

                        pageName="Assign Inquiry to Suppliers"

                        clickable={{
                            layer1: "",

                            layer2: `/${getPrefix()}${privateRoutePaths.SUPPLIER_INQUIRIES.path}`,

                            layer3: ""
                        }}

                    />


                    {selectedInquiry && (

                        <div className="company-info-details new-design supplier-inq-cards">

                            <div className="row">

                                <div className="col-xxl-5 col-xl-5 col-lg-12 d-flex">

                                    <div className="card flex-fill mb-0">

                                        <div className="company-card company-card-info flex-fill">

                                            <div className="naming-wrape">

                                                <div className="naming-pad">

                                                    <h3 className="text-break">

                                                        {
                                                            selectedInquiry.company_name
                                                        }

                                                        -

                                                        <span>

                                                            {
                                                                !isEmpty(
                                                                    selectedInquiry.inquiry_unique_id
                                                                )
                                                                    ? selectedInquiry.inquiry_unique_id
                                                                    : ' - '
                                                            }

                                                        </span>

                                                    </h3>

                                                </div>

                                            </div>


                                            <div className="middle-wrape">

                                                <div className="row">

                                                    <div className="col-xl-6 gx-4">

                                                        <p className="inquiry-detials-info text-break">

                                                            <span>
                                                                Company Name:
                                                            </span>

                                                            {" "}

                                                            {
                                                                selectedInquiry.company_name &&
                                                                    !isEmpty(
                                                                        selectedInquiry.assign_from
                                                                    ) &&
                                                                    selectedInquiry.assign_from[0]?.assign_from
                                                                    ? (

                                                                        <Link

                                                                            to={
                                                                                `/${getPrefix()}${buildPath(
                                                                                    privateRoutePaths.VIEW_COMPANY_PROFILE,
                                                                                    {
                                                                                        id:
                                                                                            selectedInquiry.assign_from[0].assign_from
                                                                                    }
                                                                                )}`
                                                                            }

                                                                            target="_blank"
                                                                        >

                                                                            {
                                                                                selectedInquiry.company_name
                                                                            }

                                                                        </Link>

                                                                    )
                                                                    : (

                                                                        <>
                                                                            {
                                                                                selectedInquiry.company_name
                                                                            }
                                                                        </>

                                                                    )
                                                            }

                                                        </p>

                                                    </div>


                                                    <div className="col-xl-6 gx-4">

                                                        <p className="text-break">

                                                            <span>
                                                                Contact Person:
                                                            </span>

                                                            {" "}

                                                            {
                                                                selectedInquiry.contact_person
                                                            }

                                                        </p>

                                                    </div>


                                                    <div className="col-xl-6 gx-4">

                                                        <p className="text-break">

                                                            <span>
                                                                Email:
                                                            </span>

                                                            {" "}

                                                            {
                                                                selectedInquiry.email
                                                            }

                                                            {
                                                                selectedInquiry.other_email
                                                                    ? `, ${selectedInquiry.other_email}`
                                                                    : ""
                                                            }

                                                        </p>

                                                    </div>


                                                    <div className="col-xl-6 gx-4">

                                                        <p className="text-break">

                                                            <span>
                                                                Phone Number:
                                                            </span>

                                                            {" "}

                                                            {
                                                                !isEmpty(
                                                                    selectedInquiry.phone
                                                                )
                                                                    ? selectedInquiry.phone
                                                                    : ' - '
                                                            }

                                                        </p>

                                                    </div>
                                                      <div className="col-xl-6 gx-4">

                                                                <p className="text-break">

                                                                    <span>
                                                                        Industry:
                                                                    </span>

                                                                    {" "}

                                                                   {industryValue === "Other" ? `Other (${selectedInquiry.industry})` : selectedInquiry.industry}

                                                                </p>

                                                            </div>


                                                            <div className="col-xl-6 gx-4">

                                                                <p className="text-break">

                                                                    <span>
                                                                        Country:
                                                                    </span>

                                                                    {" "}

                                                                    {
                                                                        selectedInquiry.country
                                                                    }

                                                                </p>

                                                            </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>


                                <div className="col-xxl-5 col-xl-5 col-lg-9 d-flex">

                                    <div className="card flex-fill mb-0">

                                        <div className="company-card company-card-info flex-fill">

                                            <div className="naming-wrape">

                                                <div className="naming-pad">

                                                    <h3>
                                                        Inquiry information
                                                    </h3>

                                                </div>

                                            </div>


                                            <div className="middle-wrape">

                                                <div className="row">

                                                    {selectedInquiry.type === "Supplier" && (

                                                        <>

                                                            <div className="col-xl-4 gx-4">

                                                                <p className="text-break">

                                                                    <span>
                                                                        Product:
                                                                    </span>

                                                                    {" "}

                                                                    {
                                                                        !isEmpty(
                                                                            selectedInquiry.product
                                                                        )
                                                                            ? selectedInquiry.product
                                                                            : " - "
                                                                    }

                                                                </p>

                                                            </div>


                                                            <div className="col-xl-4 gx-4">

                                                                <p className="text-break">

                                                                    <span>
                                                                        Quantity:
                                                                    </span>

                                                                    {" "}

                                                                    {
                                                                        !isEmpty(
                                                                            selectedInquiry.quantity
                                                                        )
                                                                            ? selectedInquiry.quantity
                                                                            : ' - '
                                                                    }

                                                                </p>

                                                            </div>


                                                            <div className="col-xl-4 gx-4">

                                                                <p className="text-break">

                                                                    <span>
                                                                        Unit:
                                                                    </span>

                                                                    {" "}

                                                                    {
                                                                        !isEmpty(
                                                                            selectedInquiry.unit
                                                                        )
                                                                            ? selectedInquiry.unit
                                                                            : ' - '
                                                                    }

                                                                </p>

                                                            </div>


                                                            {/* <div className="col-xl-4 gx-4">

                                                                <p className="text-break">

                                                                    <span>
                                                                        Inquiry ID:
                                                                    </span>

                                                                    {" "}

                                                                    {
                                                                        !isEmpty(
                                                                            selectedInquiry.inquiry_unique_id
                                                                        )
                                                                            ? selectedInquiry.inquiry_unique_id
                                                                            : ' - '
                                                                    }

                                                                </p>

                                                            </div> */}


                                                            <div className="col-xl-12 gx-4 ck-edit-cntnt">
                                                                <span className="inq-message-label">Message:</span>

                                                                <div className="inq-message-wrap">
                                                                    <div
                                                                        ref={msgRef}
                                                                        className="border-0 inq-message inq-message-clamp"
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: !isEmpty(selectedInquiry.message)
                                                                                ? selectedInquiry.message
                                                                                : ' - '
                                                                        }}
                                                                    />
                                                                    {isMsgOverflow && (
                                                                        <span className="inq-read-more-wrap">
                                                                            <span className="inq-dots">… </span>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-link p-0 inq-read-more"
                                                                                onClick={() => setShowMsgPopup(true)}
                                                                            >
                                                                                Read More
                                                                            </button>
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>

                                                        </>

                                                    )}

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>


                                <div className="col-xxl-2 col-xl-2 col-lg-3 d-flex flex-column gap-3">
                                 
                                    <div className="card count-stat-card flex-fill justify-content-center m-0 p-0">
                                        <Link
                                            to={
                                                `/${getPrefix()}${buildPath(
                                                    privateRoutePaths.SUPPLIER_INQUIRY_REPORT,
                                                    {
                                                        id:selectedInquiry.id
                                            
                                                    }
                                                )}`
                                            }
                                            target="_blank" > 
                                        <div className="d-flex align-items-center gap-3 px-4 py-2">
                                            <h4 className="count-total mb-0">
                                                {selectedInquiry.total ? selectedInquiry.total : 0}
                                            </h4>
                                            <span className="text-muted small">Total Sent</span>
                                        </div>
                                         </Link>
                                    </div>
                                   

                                    <div className="card count-stat-card flex-fill justify-content-center m-0 p-0">
                                         <Link
                                            to={
                                                `/${getPrefix()}${buildPath(
                                                    privateRoutePaths.SUPPLIER_INQUIRY_REPORT,
                                                    {
                                                        id:selectedInquiry.id
                                            
                                                    }
                                                )}`
                                            }
                                            target="_blank" > 
                                        <div className="d-flex align-items-center gap-3 px-4 py-2">
                                            <h4 className="count-open mb-0">
                                                {selectedInquiry.is_open ? selectedInquiry.is_open : 0}
                                            </h4>
                                            <span className="text-muted small">Total Open</span>
                                        </div>
                                        </Link>
                                    </div>

                                    <div className="card count-stat-card flex-fill justify-content-center m-0 p-0">
                                        <Link
                                            to={
                                                `/${getPrefix()}${buildPath(
                                                    privateRoutePaths.SUPPLIER_INQUIRY_REPORT,
                                                    {
                                                        id:selectedInquiry.id
                                            
                                                    }
                                                )}`
                                            }
                                            target="_blank" > 
                                        <div className="d-flex align-items-center gap-3 px-4 py-2">
                                            <h4 className="count-not-open mb-0">
                                                {selectedInquiry.is_not_open ? selectedInquiry.is_not_open : 0}
                                            </h4>
                                            <span className="text-muted small">Total Not Open</span>
                                        </div>
                                         </Link>
                                    </div>

                                </div>

                            </div>

                        </div>

                    )}


                    <div className='filter-section'>

                        <ViewSupplierFilter
                            inqID={inqID}
                        />

                    </div>


                    <div className='card1'>

                        <div className='table-header-name'>

                            <h5 className='table-text py-3'>
                                Supplier List
                            </h5>

                            <div className='assign-header-right py-2'>

                                <div className='assign-header-top'>

                                    {/* <div className="assign-stats">

                                        <div className="assign-stat">
                                            <span className="num assigned">{assignedCount}</span>
                                            <span className="lbl">Assigned</span>
                                        </div>

                                        <div className="assign-stat-sep"></div>

                                        <div className="assign-stat">
                                            <span className="num not-assigned">{notAssignedCount}</span>
                                            <span className="lbl">Not Assigned</span>
                                        </div>

                                    </div> */}

                                    {
                                        isSuperAdmin &&
                                        memberList.length > 0 && (

                                            <ButtonAdd
                                                className='ms-2'
                                                type="button"
                                                onClick={handleInqAssign}
                                            >
                                                Assign
                                            </ButtonAdd>

                                        )
                                    }

                                </div>

                                {/* {
                                    memberList.length > 0 && (

                                        <div className="text-center text-black">

                                            Showing 1 to {
                                                memberList.length
                                            } of {
                                                totalRows
                                            }

                                        </div>

                                    )
                                }  */}

                                {memberList.length > 0 && (
                                    <div className="text-center text-black">
                                        <div>
                                            Showing 1 to {memberList.length} of {totalRows}
                                        </div>
                                        {/* <div>
                                            <span>Assigned: <b>{assignedCount}</b></span>
                                            {" | "}
                                            <span>Not Assigned: <b>{notAssignedCount}</b></span>
                                        </div> */}
                                    </div>
                                )}

                            </div>

                        </div>


                        <div className="table-wrapper">

                            <div className="table-container">


                                {
                                    memberList && (

                                        <AcSimpleTable

                                            key={tableKey}

                                            data={
                                                memberList
                                            }

                                            title=""

                                            pagination={false}

                                            columns={
                                                columns
                                            }

                                            progressPending={
                                                loading
                                            }

                                            fixedColumnsStart={
                                                admin.FIXED_COLUMNS_START
                                            }

                                            offset={
                                                offset
                                            }

                                            limit={
                                                limit
                                            }

                                            columnName={
                                                columnName
                                            }

                                            sortDirection={
                                                sortDirection
                                            }

                                            setLimit={
                                                (value) => {

                                                    const newLimit =
                                                        Number(
                                                            typeof value === 'function'
                                                                ? value(limit)
                                                                : value
                                                        );

                                                    setLimit(
                                                        newLimit
                                                    );

                                                    limitRef.current =
                                                        newLimit;

                                                }
                                            }

                                            setOffset={
                                                (value) => {

                                                    const newOffset =
                                                        Number(
                                                            typeof value === 'function'
                                                                ? value(offset)
                                                                : value
                                                        );

                                                    setOffset(
                                                        newOffset
                                                    );

                                                    offsetRef.current =
                                                        newOffset;

                                                }
                                            }

                                            setColumnName={
                                                setColumnName
                                            }

                                            setSortDirection={
                                                setSortDirection
                                            }

                                            setLoading={
                                                setLoading
                                            }

                                            current_page={
                                                current_page
                                            }

                                            setCurrentPage={
                                                setCurrentPage
                                            }

                                            paginationTotalRows={
                                                totalRows
                                            }

                                            striped

                                            sortServer

                                            onSort={
                                                handleSort
                                            }

                                            defaultSortAsc={
                                                false
                                            }

                                            noData={
                                                nodata
                                            }

                                            searchTxt={
                                                searchTxt
                                            }

                                        />

                                    )
                                }


                                <div
                                    ref={sentinelRef}
                                    style={{
                                        height: '1px'
                                    }}
                                />


                                {/* {
                                    isFetchingMore && (

                                        <div className="text-center py-3">

                                            Loading...

                                        </div>

                                    )
                                } */}


                                {
                                    !hasMore &&
                                    memberList.length > 0 && (

                                        <div className="text-center py-3 text-muted">

                                            (
                                            {
                                                memberList.length
                                            }
                                            ) member's found

                                        </div>

                                    )
                                }


                                {
                                    hasMore && (

                                        <div className='load-more text-center py-3'>

                                            <ButtonAdd

                                                type='button'

                                                className='ms-1'

                                                onClick={
                                                    loadMoreMembers
                                                }

                                                disabled={
                                                    buttonDisabled ||
                                                    isFetchingMore
                                                }

                                            >

                                                Load More

                                            </ButtonAdd>

                                        </div>

                                    )
                                }


                            </div>

                        </div>

                    </div>

                    <MediumPopup
                        title="Assign Inquiry"
                        mediummodalShow={smallmodalShow}
                        setMediumModalShow={setSmallModalShow}
                        onSubmit={handleAssign}
                        closeButtonLabel="Cancel"
                        okButtonLabel="Assign"
                        disabled={isButtonDisabled}
                    >
                        <div className="assign-inquiry-content text-center py-3 px-2">
                        {isDefaultAssign ? (
                            <>
                             <div className="assign-inquiry-icon assign-warning-icon d-flex align-items-center justify-content-center rounded-circle mx-auto mb-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="38"
                                    height="38"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    aria-hidden="true"
                                >
                                    <path d="M10.3 3.9 2.7 17a2 2 0 0 0 1.7 3h15.2a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
                                    <path d="M12 9v4" />
                                    <path d="M12 17h.01" />
                                </svg>
                            </div>

                            <h5 className="assign-inquiry-title assign-warning-title mb-3">
                                Please Select Filters
                            </h5>

                            <p className="assign-inquiry-description mx-auto mb-3">
                                You haven’t selected any filter. If you proceed, the inquiry will be assigned to 100 users.
                            </p>

                            <p className="assign-inquiry-description mx-auto mb-3">
                                To assign inquiries to the right person, please select at least one filter (e.g., Country, Industry, or Inquiry Type).
                            </p>
                            </>
                            ) : (
                                 <>
                                


                            <div className="assign-inquiry-icon d-flex align-items-center justify-content-center rounded-circle mx-auto mb-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="38"
                                    height="38"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <rect x="5" y="4" width="14" height="18" rx="2" />
                                    <path d="M9 4.5V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1.5" />
                                    <path d="m9 14 2 2 4-4" />
                                </svg>
                            </div>

                            <span className="assign-inquiry-badge d-inline-flex align-items-center gap-2 rounded-pill px-3 py-1 mb-3">
                                <i className="fa-solid fa-check"></i>
                                Recommended
                            </span>

                            <h5 className="assign-inquiry-title mb-2">
                                Confirm Assignment
                            </h5>

                            <p className="assign-inquiry-description mx-auto mb-3">
                                You are about to assign the selected inquiries to their
                                matching suppliers. Please confirm to proceed with the
                                assignment process.
                            </p>
                                </>
                            )}

                        </div>
                    </MediumPopup>
                    {/* <MediumPopup
                        title="Assign Inquiry"
                        mediummodalShow={smallmodalShow}
                        setMediumModalShow={setSmallModalShow}
                        onSubmit={handleAssign}
                        closeButtonLabel="Cancel"
                        okButtonLabel="Assign"
                        disabled={isButtonDisabled}
                    >
                        <div className="assign-inquiry-content text-center py-3 px-2">

                            <div className="assign-inquiry-icon assign-warning-icon d-flex align-items-center justify-content-center rounded-circle mx-auto mb-3">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="38"
                                    height="38"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    aria-hidden="true"
                                >
                                    <path d="M10.3 3.9 2.7 17a2 2 0 0 0 1.7 3h15.2a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
                                    <path d="M12 9v4" />
                                    <path d="M12 17h.01" />
                                </svg>
                            </div>

                            <h5 className="assign-inquiry-title assign-warning-title mb-3">
                                Please Select Filters
                            </h5>

                            <p className="assign-inquiry-description mx-auto mb-3">
                                You haven’t selected any filter. If you proceed, the inquiry will be assigned to 100 users.
                            </p>

                            <p className="assign-inquiry-description mx-auto mb-3">
                                To assign inquiries to the right person, please select at least one filter (e.g., Country, Industry, or Inquiry Type).
                            </p>

                        </div>
                    </MediumPopup> */}
                    <MediumPopup
                        title="Inquiry Message"
                        mediummodalShow={showMsgPopup}
                        setMediumModalShow={setShowMsgPopup}
                    >
                        <div
                            className="border-0 inq-message"
                            dangerouslySetInnerHTML={{
                                __html: `<p class="border-0" style="border-bottom: 0px solid #f3f3f3 !important"><span>Message:</span> ${!isEmpty(selectedInquiry?.message)
                                    ? selectedInquiry.message
                                    : ' - '
                                    }</p>`
                            }}
                        />
                    </MediumPopup>


                </div>

            </div>

        </>

    );
}


/*
|--------------------------------------------------------------------------
| Redux
|--------------------------------------------------------------------------
*/

const mapStateToProps = () => {

    return {};

};


const mapDispatchToProps = (
    dispatch
) => {

    return {

        showLoading: () =>
            dispatch(
                showLoading()
            ),

        hideLoading: () =>
            dispatch(
                hideLoading()
            ),

        FilterSupplierMembers:
            (filterData) =>
                dispatch(
                    FilterSupplier(
                        filterData
                    )
                ),

        getAllSupllierForInq:
            () =>
                dispatch(
                    getAllSupllierInq()
                ),

        getInquiries:
            (id) =>
                dispatch(
                    getOneInquiry(id)
                ),

        assignBulkInq:
            (member_ids) =>
                dispatch(
                    assignBulkInqquiry(
                        member_ids
                    )
                ),
            getCategories: () => dispatch(getCategories()),

    };
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewSupplier);
